/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {isDevMode} from '../utils/env';

/**
 * Launches Redux Dev Tools when an Application is being run in Development Mode.
 */
export const launchReduxDevTools = () => {
  if (isDevMode()) {
    const position = 'right';
    if (window.__REDUX_DEVTOOLS_EXTENSION__) {
      window.__REDUX_DEVTOOLS_EXTENSION__.open(position);
    } else if (window.devToolsExtension) {
      window.devToolsExtension.open(position);
    }
  }
};
export default launchReduxDevTools;
